import { MoneySchema } from "@redotech/money";
import * as z from "zod/v4";

export const getRescuePanelAttribution = {
  name: "getRescuePanelAttribution" as const,
  input: z.null(),
  output: z.object({
    revenueFromPanel: MoneySchema,
    numImpressions: z.number(),
    numEngagements: z.number(),
    numOrders: z.number(),
    conversionRate: z.number(),
    conversionRateChangeComparedToPreviousPeriod: z.number(),
  }),
};
